import React from 'react';
import {
  Row,
  Form,
  TextIconButton,
  ArrowLeftIcon,
  RotateIcon,
} from 'shared-portal-component';
import { z } from 'zod';

const CODE_LENGTH = 6;

const schema = z.object({
  code: z
    .string()
    .length(CODE_LENGTH, `Code must be exactly ${CODE_LENGTH} digits`)
    .regex(/^\d+$/, 'Code must contain only digits'),
});

interface AuthCodeProps {
  onBack: () => void;
  onResend: () => void;
  onSubmit: (code: string) => void | Promise<void>;
  loading?: boolean;
  error?: string;
}

const AuthCode: React.FC<AuthCodeProps> = ({
  onBack,
  onResend,
  onSubmit,
  loading,
  error,
}) => {
  // Field configuration for Form
  const fields = [
    {
      name: 'code',
      label: 'Code',
      placeholder: 'Enter the 6-digit code',
      required: true,
      variant: 'outline' as const,
      type: 'code',
      numValues: CODE_LENGTH,
    },
    {
      type: 'display',
      name: 'auth-code',
      label: 'AuthCode',
      display: (
        <Row spacing="none" justify="between">
          <TextIconButton
            icon={<ArrowLeftIcon />}
            text="Back"
            variant="outline"
            size="sm"
            onClick={onBack}
            type="button"
          />
          <TextIconButton
            icon={<RotateIcon />}
            text="Resend"
            variant="outline"
            size="sm"
            onClick={onResend}
            type="button"
            disabled={loading}
          />
        </Row>
      ),
    },
  ];

  return (
          <Form
            schema={schema}
            fields={fields}
            onSubmit={(values: { code: string }) => {
              void onSubmit(values.code);
            }}
          />
  );
};

export default AuthCode;
